import { type FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';

import styles from './PhotoPositionIndicator.scss';

type Props = {
    photoCount: number;
    photoIndex: number;
};

const PhotoPositionIndicator: FC<Props> = props => {
    const { photoCount, photoIndex } = props;
    // hide on loading...
    if (photoCount === 0) {
        return null;
    }
    return (
        <div className={styles.positionIndicatorWrapper}>
            <span className={styles.positionIndicator}>
                <FormattedMessage
                    id="interiorPhoto.photo.overlay.position"
                    defaultMessage="{current} of {count}"
                    values={{
                        current: photoIndex + 1,
                        count: photoCount,
                    }}
                />
            </span>
        </div>
    );
};

export default PhotoPositionIndicator;
